import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import TinyMCE from 'react-tinymce';
import Contacts  from './Contacts';
const jQuery=window.jQuery;
const $= window.$;

class Compose extends Component {
	constructor(props) {
		super(props);
        this.state={
            contactForm : <Contacts sentData={this.getData}/>,
            mailids : '',
            AllDatas:[],
            editorcontent:'',
        };
        this.slide = this.slide.bind(this);
        this.getData = this.getData.bind(this);
        this.Submit = this.Submit.bind(this);
        this.handleEditorChange=this.handleEditorChange.bind(this);

	}

    componentWillReceiveProps(nextProps) {

	}

	handleEditorChange(e) {
       this.setState({editorcontent:e.target.getContent()});
   
  	}

	slide(){
		$(".insert-mail").slideToggle();
		this.setState({
			contactForm : <Contacts sentData={this.getData}/>
		})
	}

	
	Submit(){
		let formData = new FormData();
		 let compose=$('form#compose_data').serializeArray();
		 let role = Common.getUserData("role", true);
		   let details = [];
		   formData.append("lr_id", Common.getUserData("id", true));
		   formData.append("message", this.state.editorcontent);
		   formData.append("lr_name", Common.getUserData("fullName", true))
		   formData.append("allData", this.state.AllDatas);
		   compose.map((key,index)=>{
		        details.push({[key.name]:key.value});
		        formData.append(key.name,key.value);
		   });

			let val = 0;
		   	$.each($('form#compose_data').find('input[type="file"]'), function(i, tag) {
			      $.each($(tag)[0].files, function(i, file) {
			        formData.append(tag.name+val, file);
			        val++;
			      });
			});
			formData.append("count",val);
			formData.append("admin_role",role);
			//console.log(details);
		   fetch(Config.domainUrl +"messages-site/compose", {
		     method: "POST",
			   headers: {
			       'Accept': 'application/json',
						 'Authorization':'Bearer ' +Common.getTokenData()
			      },
			    body: formData,
			   }).then((response) => response.json()).then((responseJson) => {
			   	if (responseJson.status == 0) {
			      Common.message(responseJson.message, responseJson.errors, "error");
			    } else {
			      Common.message("", responseJson.message, "success");
			      $('.MultiFile-remove').click();
			      $('form#compose_data')[0].reset();
			      this.setState({
			      	mailids:'',
			      	AllDatas:'',
			      })
			    }


		});
	}
   
	getData(mailid,AllDatas){
		this.setState({
			mailids:mailid,
			AllDatas:AllDatas,
		})
	}

    componentDidMount() {
   		$("input[type=file].multi").MultiFile();
    }




		render() {
			
			return (
				<div >
					<h2>Messages - Compose</h2>
					<form name="compose" id="compose_data" encType="multipart/form-data">
						<div className="message-chart">
								<div className="message-form-left">
									<ul>
					                	<li >
						                  <label>To :</label>
						                </li>
										<li>
											<div id="divToaddress" className="toaddress" style={{width:"574px"}}>{this.state.mailids}</div>
											<a href="javascript:void(0);" className="orange" onClick={(e)=>this.slide(e)}>Insert addresses</a> 
											<div className="insert-mail" style={{display:'none'}}>{this.state.contactForm}</div>
						            	</li>
						                <div className="clear"></div>
						                <li >
						                  <label>Subject :</label>
						                </li>
						                <li>
						                  <input type="text" name="subject" id="txtSubject" className="txtbox" />
						                </li>
						                <div className="clear"></div>
						                <li >
						                  <label>Message :</label>
						                </li>
						                <li>
						                  {/*<textarea cols="5" rows="60" className="mail_txtarea" name="message" id="composemail_txtarea" ></textarea>*/}
						                  <div style={{float:'left', width:'100%'}}>  
                   
					                        <TinyMCE
					                            ref="messgeseditor"
					                            config={{
					                            menubar: true,    
					                            plugins: 'autolink link image lists print preview',
					                            toolbar: 'bold italic | alignleft aligncenter alignright',
					                            branding: false
					                            }}
					                            onChange={this.handleEditorChange}
					                        />
							            
							            	<div id="div_writing_txtarea" className="error" ></div>
					                      </div>  
						                </li>
						    			<div className="clear"></div>
						                <li className="last-height">
						                  <label>Attachment :</label>
						                </li>
						                <li> 
						                	<input type="file" id="attachment" name="attachment" size="80" className="multi" accept="xls|pdf|doc|ppt|pps|jpg|gif|txt" maxLength="6" />
						                	<span className="file-text">( Only XLS,Doc,PDF,PPT,PPS,JPG,GIF,TXT Format )</span>
						                </li>
						                <li><input type="button" name="btnsend" value="Send" alt="Send" title="Send" onClick={(e)=>this.Submit(e)}/></li>
						  			</ul>    
									<input type="hidden" name="toaddress" id="toaddress" value={this.state.mailids}/>	
								</div>                      
							</div>
					</form>
				</div>
			);
		}
}

export default Compose;



// WEBPACK FOOTER //
// ./src/personal_interactions/messages/Compose.js